var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"record-box"},[(_vm.showResult)?_c('ax-result-page',{attrs:{"type":"network","subtext":"要不然下拉刷新试试？"}}):_vm._e(),_vm._l((_vm.recordList),function(item,index){return _c('ax-ehr-step',{key:index,attrs:{"data":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }